import { render, staticRenderFns } from "./ExamApplication.vue?vue&type=template&id=05a9a562&"
import script from "./ExamApplication.vue?vue&type=script&lang=js&"
export * from "./ExamApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports